module.exports = __webpack_public_path__ + "static/media/icon_editing_btn.72c7bb62.svg";